
import Group from 'vux/src/components/group/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Popover from 'vux/src/components/popover/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import config from '@/config/index'
import CountDown from '@/components/vue2-countdown'
import CountDown2 from '@/components/vue2-countdown-other'
import { addPartyCount, cutCreditParty } from '@/api/jfhl.js'
import { operateCreditlist } from '@/api/user.js'
import { selectPartyDetails, quotationStatistics, quotedPrice, selectQuotationTimes } from '@/api/jingcai.js'

let echarts = require('echarts/lib/echarts')

require('echarts/lib/chart/line')

require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
export default {
directives: {
TransferDom
},
components: {
Group,
Flexbox,
FlexboxItem,
PopupPicker,
CountDown,
CountDown2,
Popover
},
data () {
return {
baseUrl: config.baseUrl,
selected: 0,
tablist: [{
title: '进行中'
}, {
title: '即将开始'
}],
averagePrice: [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
[0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
[0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
[0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
['.'],
[0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
[0, 1, 2, 3, 4, 5, 6, 7, 8, 9]],
averageValue: [0, 0, 0, 0, '.', 0, 0],
showPopupPicker: false,
partyid: this.$route.params.partyid,
productproceed: {},
producttrailer: {},
isclick: true,
dateX: [],
pricelist: [],
dataprice: [],
currentTime: '',
start: '',
end: '',
start2: '',
end2: '',
isExplain: false
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
},
mobile () {
return this.$store.state.user.personObj.mobile
}
},
mounted () {
let timestamp = (new Date()).getTime()
this.currentTime = timestamp
this.view()
this.addIntegral()

},
watch: {
},
methods: {

isCurrentTime (beginTime, endTime) {
var currentTime = new Date()
var beginTime = new Date(beginTime)
var endTime = new Date(endTime)
if (currentTime < beginTime) {
this.isclick = false
return false
}
if (currentTime >= endTime) {
this.isclick = false
return false
}
this.isclick = true
},

addcount () {
addPartyCount({
partyid: this.partyid,
accoutid: this.accountid,
credittype: 1
}).then(res => {
})
},

addIntegral (credit) {
operateCreditlist({
accountid: this.accountid,
rulecode: 'party_rule',
credit: 5,
owner_type: '2007',
relationtype: 2,
relationid: 1,
terminaltype: 2
}).then(res => { })
},

view () {
selectPartyDetails({
id: this.partyid
}).then(res => {
if (res.success) {
this.startTime = res.obj.startdate.replace(/-/g, '/')
this.endTime = res.obj.enddate.replace(/-/g, '/')
this.isCurrentTime(this.startTime, this.endTime)
res.obj.commodityList.forEach((item, index) => {
if (item.state === 3) {
this.start = item.startdate
this.end = item.enddate
this.productproceed = item
this.isclick = true
this.statistical(item.id)
window.setInterval(() => {
setTimeout(this.statistical(item.id), 0)
}, 1200000)
} else if (item.state === 2) {
this.start2 = item.startdate
this.end2 = item.enddate
this.producttrailer = item
this.isclick = false
} else {
this.isclick = false
}
})
}
})
},

statistical (id) {
quotationStatistics({
goodsid: id
}).then(res => {
if (res.success) {
this.dateX = []
this.dataprice = []
res.obj.forEach((item, index) => {
if (new Date(Object.keys(item)[0].replace(/-/g, '/')) <= new Date(this.productproceed.enddate.replace(/-/g, '/'))) {
this.dateX.push(Object.keys(item).join(',').slice(11, 16))
this.dataprice.push(Object.values(item).join(','))
}
})
this.drawLine()
}
})
},

drawLine () {
let myChart = echarts.init(document.getElementById('myChart'))
myChart.setOption({
title: {
text: ''
},
tooltip: {
formatter: function (params) {
let res = ''
res = params.seriesName + '：' + params.value
return res
}
},
legend: {},
grid: {
left: '3%',
right: '4%',
bottom: '3%',
containLabel: true
},
toolbox: {
feature: {
saveAsImage: {}
}
},
xAxis: {
type: 'category',
default: true,
data: this.dateX,
axisLabel: {
show: true,
rotate: 30,
interval: 0,
boundaryGap: false,
textStyle: {
color: '#ac7d24'
}
},
axisLine: {
lineStyle: {
color: '#cadcf3', // 颜色
width: 1 
}
}
},
yAxis: {
type: 'value',
name: '单位：元',
axisLine: {
lineStyle: {
color: '#cadcf3', // 颜色
width: 1 
}
},
axisLabel: {
show: true,
textStyle: {
color: '#7eb1f4'
}

},
splitLine: {
show: true,
lineStyle: {
color: '#e9f2fe'
}
},
max: parseInt(this.productproceed.highestPrice),
min: 0,
splitNumber: 5
},
series: [
{
name: '竞猜价格',
type: 'line',
stack: '总量',
symbol: 'circle', // 折线点设置为实心点
symbolSize: 10, // 折线点的大小
data: this.dataprice,
itemStyle: {
normal: {
color: '#f45e23',
label: { show: true },
lineStyle: {
color: '#ffae00'
}
}
}
}
]
})
},

cutCredit (credit) {
cutCreditParty({
accoutid: this.accountid,
credit: credit,
partyid: this.productproceed.id,
partytype: 1
}).then(res => { })
},
offer (type) {
if (type) {
let average = this.averageValue.join().replace(/,/g, '').replace(/^0+/g, '')
if (average <= 0) {
this.$vux.toast.text('报价价格不能等于0！')
return false
}
if (average > this.productproceed.highestPrice) {
this.$vux.toast.text('报价价格不能超过商品最高价！')
return false
}
quotedPrice({
openid: this.accountid,
price: average,
goodsid: this.productproceed.id,
phoneNumber: this.mobile
}).then(res => {
if (res.success) {

this.cutCredit(10)
this.$vux.toast.text('报价成功！')
}
})
}
},

gorule () {
this.$router.push({ name: 'pingjunjiaResult3' })
},
ontab (index) {
this.selected = index
let timestamp = (new Date()).getTime()
this.currentTime = timestamp
if (index === 0) {
if (Object.keys(this.productproceed).length > 0) {
this.statistical(this.productproceed.id)
}
}
},
opendiv () {
selectQuotationTimes({
openid: this.accountid,
goodsid: this.productproceed.id
}).then(res => {
if (res.success) {
if (res.obj >= this.productproceed.frequency) {
this.$vux.toast.text('报价次数超过上限')
} else {
if (this.isclick) {
this.averageValue = [0, 0, 0, 0, '.', 0, 0]
this.showPopupPicker = true
}
}
}
})
},
openExplain () {
let _this = this
this.isExplain = !this.isExplain
setTimeout(function () {
_this.isExplain = false
}, 8000)
},
times () {
selectQuotationTimes({
openid: this.accountid,
goodsid: this.productproceed.id
}).then(res => {
if (res.success) {
if (res.obj >= this.productproceed.frequency) {
this.$vux.toast.text('报价次数超过上限')
return false
}
}
})
}

}
}
